import React from 'react'
import styled from '@emotion/styled'
import { Box, Button, Typography } from '@mui/material'
import TrendingUpIcon from '@mui/icons-material/TrendingUp'

const EmptyStateContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 0;
  height: 100%;
  text-align: center;
  background-color: #e8f3ff;
  font-family: 'Helvetica Neue' !important;
`

const IconContainer = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f5f5f5;
  border-radius: 50%;
  width: 80px;
  height: 80px;
  margin-bottom: 24px;
`

const StyledIcon = styled(TrendingUpIcon)`
  color: #2e5bff;
  font-size: 32px;
`

const MessageText = styled(Typography)`
  margin-bottom: 24px;
  font-family: 'Helvetica Neue' !important;
  font-size: 16px;
`

const TitleText = styled(Typography)`
  margin-bottom: 24px;
  font-family: 'Helvetica Neue' !important;
  font-size: 18px;
`

type EmptyStateProps = {
  onAddData: () => void
}

export const EmptyState = ({ onAddData }: EmptyStateProps) => (
  <EmptyStateContainer>
    <IconContainer>
      <StyledIcon />
    </IconContainer>
    <TitleText>No Records To Show</TitleText>
    <MessageText variant='body1'>
      Add data to begin tracking this goal&apos;s progress.
    </MessageText>
    <Button
      variant='outlined'
      onClick={onAddData}
      sx={{
        margin: 0,
        borderRadius: '20px',
        padding: '6px 24px',
        textTransform: 'none',
        fontWeight: 500,
        backgroundColor: 'white',
      }}
    >
      Add Progress
    </Button>
  </EmptyStateContainer>
)
